module.exports = __webpack_public_path__ + "static/ams-3410c200c0b3452bf5bb12bbad655dc0.jpg";